import { queryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import type { UnusedSkipTokenOptions } from '@tanstack/react-query'
import type { HTTPError } from 'ky'
import type { HttpErrorResponse } from '@/types/error'
import { paymentService } from '@/services'

export const getPaymentMethodsQueryOptions = (
  params: Parameters<typeof paymentService.methods>[0],
) =>
  queryOptions({
    queryKey: queryKeys.payment.methods(params),
    queryFn: ({ signal }) => paymentService.methods(params, { signal }),
  })

export const getBankAccountsQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.payment.bankAccounts(),
    queryFn: ({ signal }) => paymentService.bankAccounts({ signal }),
  })

export const getSelectedPaymentMethodOptions = (
  params: Parameters<typeof paymentService.methodSelect>[0],
  options?: Omit<
    UnusedSkipTokenOptions<
      Awaited<ReturnType<typeof paymentService.methodSelect>>,
      HTTPError<HttpErrorResponse>,
      Awaited<ReturnType<typeof paymentService.methodSelect>>,
      ReturnType<typeof queryKeys.payment.methodSelected>
    >,
    'queryKey' | 'queryFn'
  >,
) =>
  queryOptions({
    queryKey: queryKeys.payment.methodSelected(params),
    queryFn: ({ signal }) => paymentService.methodSelect(params, { signal }),
    ...options,
  })
